<template>
    <v-content>
        <v-container>
            <v-layout align-center justify-center fill-height>
              <v-overlay
                :opacity="0.90"
                  :value="info_invitation[0].canceled"
              >
                <div class="text-center">
                  <h2>{{$t('canceled_invitation')}}</h2><br>
                  <h2>{{$t('msg_canceled_invitation_offline')}}</h2><br>
                </div>
              </v-overlay>
                <v-flex xs12 sm7 md6 lg5 xl3>
                    <h2 style="text-align: center;">
                        <strong>
                            <span style=" text-align: center;">Has recibido una invitaci&oacute;n del Fraccionamiento</span>
                        </strong>
                    </h2>
                    <p style="text-align: center;">
                        <span style="background-color: #2b2301; color: #fff; display: inline-block; padding: 3px 10px; font-weight: bold; border-radius: 5px;">{{ info_invitation[0].housing_unit_name }}</span>
                        <br>
                        <img
                            :src="info_invitation[0].logo"
                            width="150px"
                        >
                    </p>
                    <p style="text-align: center;">Solo muestra el siguiente código en la caseta de la entrada</p>
                    <p style="text-align: center;"><strong>Fecha y Hora: {{ info_invitation[0].date }}  {{info_invitation[0].time}}</strong></p>
                    <v-card>
                        <v-toolbar class="mb-auto" dark color="primary">
                            <v-toolbar-title style="text-align: center;">
                                {{$t('qr_code')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="mt-4">
                            <v-row>
                                <v-flex xs12>
                                    <v-img
                                            class="centrado"
                                            :src="url"
                                            width="200"
                                            height="200"
                                    >
                                    </v-img>
                                    <p style="text-align: center;">
                                        <strong><span style="color: #000000;">Código:{{ codigo_qr }}</span></strong>
                                    </p>
<!--                                    <div v-if="info_invitation[0].secEqu.length > 0">-->
<!--                                        <h4 style="text-align: center;">Equipo de Seguridad Necesario:</h4>-->
<!--                                        <ul style="text-align: center" v-for="item in info_invitation[0].secEqu">-->
<!--                                            <li style="list-style:none;"><strong>{{item.nameEquipment}}</strong></li>-->
<!--                                        </ul>-->
<!--                                    </div>-->
<!--                                    <div v-else>-->
<!--                                        <h4 style="text-align: center;"><strong>Equipo de seguridad No Requerido</strong></h4>-->
<!--                                    </div>-->
<!--                                    <div style="text-align: center;">-->
<!--                                        <v-btn-->
<!--                                                class="white&#45;&#45;text"-->
<!--                                                :href="url_confirmar"-->
<!--                                                color="primary"-->
<!--                                        >-->
<!--                                            <v-icon left dark>mdi-check</v-icon>Confirmar Asistencia-->
<!--                                        </v-btn>-->
<!--                                    </div>-->
<!--                                    <div style="text-align: center;">-->
<!--                                        <a :href="urlWallet">-->
<!--                                            <v-img-->
<!--                                                    class="centrado"-->
<!--                                                    border="0"-->
<!--                                                    :src="require('../../assets/wallet.png')"-->
<!--                                                    width="150"-->
<!--                                                    contain>-->
<!--                                            </v-img>-->
<!--                                        </a>-->
<!--                                    </div>-->
                                    <br>
                                    <div style="text-align: center;">
                                        <v-icon>mdi-map-marker</v-icon>
                                        <a :href="info_invitation[0].url_map">Ubicación en Google Maps</a>
                                    </div>
                                </v-flex>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
import axios from 'axios'

export default {
  name: 'qr_code',
  data () {
    return {
      url: 'https://api.qrserver.com/v1/create-qr-code/?data=' + this.$route.params['qrcode'] + '&ecc=M&margin=20&size=400x400',
      codigo_qr: this.$route.params['qrcode'],
      url_confirmar: 'https://clubtest.intrare.app/Invitation/ConfirmedFromMail/' + this.$route.params['qrcode'] + '/True' + '/',
      urlWallet: 'https://clubtest.intrare.app/wallet/create/' + this.$route.params['qrcode'],
      info_invitation: []
    }
  },
  created: async function () {
    await this.get_info_invitation()
  },
  methods: {
    get_info_invitation () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/Invitation/Get/' + this.$route.params['qrcode'] + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language
        }
      }
      axios(config)
        .then(result => {
          this.info_invitation = result.data
          console.log(this.info_invitation)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }
</style>
